export enum GraduateInviteStatus {
  Pending = 'Pending',
  Redeemed = 'Redeemed',
  Revoked = 'Revoked',
  Expired = 'Expired',
}

export interface GraduateInvite {
  id: string;
  email: string;
  status: GraduateInviteStatus;
  createdAtUtc: string;
  expiresAtUtc: string;
  verifiedAtUtc?: string;
  redeemedAtUtc?: string;
  revokedAtUtc?: string;
  invitedByUserId: string;
  invitedByUserName: string;
}
